import React, { useState, useEffect } from 'react';
import './DashboardUsers.css'
import PieChartCard from '../../DashboardComponents/PieChartCard/PieChartCard';
import MuiTable from '../../DashboardComponents/MuiTable/MuiTable';
import RowBarChartCard from '../../DashboardComponents/RowBarChartCard/RowBarChartCard';

export default function DashboardUsers({data}) {

    // Table Data
    const tableDatatest = [{
        "id": 1,
        "first_name": "Mada",
        "last_name": "Gallandre",
        "email": "mgallandre0@ted.com",
        "gender": "Female",
        "ip_address": "41.204.181.52"
      }, {
        "id": 2,
        "first_name": "Ari",
        "last_name": "Gowrie",
        "email": "agowrie1@scientificamerican.com",
        "gender": "Male",
        "ip_address": "226.77.9.209"
      }, {
        "id": 3,
        "first_name": "Fee",
        "last_name": "Pittendreigh",
        "email": "fpittendreigh2@ocn.ne.jp",
        "gender": "Male",
        "ip_address": "206.152.192.3"
      }, {
        "id": 4,
        "first_name": "Larisa",
        "last_name": "Stening",
        "email": "lstening3@apple.com",
        "gender": "Female",
        "ip_address": "10.47.113.72"
      }, {
        "id": 5,
        "first_name": "Iseabal",
        "last_name": "Markwelley",
        "email": "imarkwelley4@pen.io",
        "gender": "Female",
        "ip_address": "178.76.77.94"
      }, {
        "id": 6,
        "first_name": "Terence",
        "last_name": "Wrintmore",
        "email": "twrintmore5@qq.com",
        "gender": "Male",
        "ip_address": "59.104.74.121"
      }, {
        "id": 7,
        "first_name": "Michal",
        "last_name": "Van der Linde",
        "email": "mvanderlinde6@cocolog-nifty.com",
        "gender": "Non-binary",
        "ip_address": "30.251.163.212"
      }, {
        "id": 8,
        "first_name": "Jeni",
        "last_name": "Ciccerale",
        "email": "jciccerale7@deviantart.com",
        "gender": "Female",
        "ip_address": "102.35.162.0"
      }, {
        "id": 9,
        "first_name": "Mark",
        "last_name": "Bulley",
        "email": "mbulley8@buzzfeed.com",
        "gender": "Male",
        "ip_address": "77.138.178.172"
      }, {
        "id": 10,
        "first_name": "Enos",
        "last_name": "MacCaughan",
        "email": "emaccaughan9@oaic.gov.au",
        "gender": "Male",
        "ip_address": "30.229.245.232"
      }];

    const [tableData, settableData] = useState({
      data: [],
    });

    // Pie chart data
    const [pieChartDataSchools, setpieChartDataSchools] = useState({
      series: [],  
      labels: [],
    });

    const [pieChartDataUsers, setpieChartDataUsers] = useState({
      series: [],  
      labels: [],
    });

    const [rowBarChartData, setrowBarChartData] = useState({
      series: [
          {
            data: [] // Start with an empty array
          }
      ],
      categories: [] // Start with an empty array,
    });

    useEffect(() => {
      if (data) {
        setrowBarChartData({
          series: [
            {
              data: Object.values(data.top5userSkillSet)
            }
          ],
          categories: Object.keys(data.top5userSkillSet)
        })

        setpieChartDataSchools({
          series: Object.values(data.schoolscomposition.percentage),
          labels: Object.values(data.schoolscomposition.course)
        })

        setpieChartDataUsers({
          series: Object.values(data.usercomposition.percentage),
          labels: Object.values(data.usercomposition.year)
        })

        const transformedData = Object.keys(data.usersTableData.id).map(key => ({
          id: data.usersTableData.id[key],
          username: data.usersTableData.username[key],
          first_name: data.usersTableData.first_name[key],
          last_name: data.usersTableData.last_name[key],
          course: data.usersTableData.course[key],
          mat_year: data.usersTableData.mat_year[key],
          profile_pic: data.usersTableData.profile_pic[key],
          user_type: data.usersTableData.user_type[key],
          regdate: data.usersTableData.regdate[key],
          last_login_date: data.usersTableData.last_login_date[key],
        }));

        settableData({
          data: transformedData
        });

        // console.log(tableData)
      }
    }, [data])

    return (
      <div>
        <div className='usersrow1'>
          <RowBarChartCard rowBarChartData={rowBarChartData} label={'Top 5 user skillset'} />
          <PieChartCard pieChartData={pieChartDataSchools} pieChartHeight={175} pieChartWidth={500} pieChartTitle='Student school composition'/>
          <PieChartCard pieChartData={pieChartDataUsers} pieChartHeight={175} pieChartTitle='Student year composition'/>
        </div>
        <div className='usersrow2'>
          <MuiTable tableData={tableData.data}/>
        </div>
      </div>
    );
}